import type { ReactElement } from 'react';
import React, { useSyncExternalStore } from 'react';

import { CameraIcon } from '../icons/CameraIcon';
import { getSnapshot, subscribe } from '@/hooks/cameraDragStore';

// Keeps the chip clear of the cursor so it never hides the drop target.
const POINTER_OFFSET_PX = 12;

/**
 * The chip that follows the pointer while a camera is being dragged out of a
 * list. Mounted once, above everything: a drag crosses panel boundaries, so the
 * thing being dragged cannot live inside the panel it started in.
 */
export const CameraDragLayer = (): ReactElement | null => {
    const { payload, point } = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
    if (!payload || !point) {
        return null;
    }
    return (
        <div
            className="pointer-events-none fixed z-[100] flex max-w-56 items-center gap-1.5 rounded border border-occ-border-2 bg-occ-background-card px-2 py-1 text-xs text-occ-foreground-main shadow-lg"
            style={{ left: point.x + POINTER_OFFSET_PX, top: point.y + POINTER_OFFSET_PX }}
        >
            <CameraIcon className="size-3.5 shrink-0 text-occ-foreground-secondary" />
            <span className="truncate">{payload.name || payload.deviceId}</span>
        </div>
    );
};
